import React, { Component } from "react";
import { Form, Icon, Input, Button, Checkbox } from "antd";
import { connect } from "react-redux";
import { login, getCsrfToken } from "../action/login.action";
import { Redirect } from "react-router-dom";
import {Row , Col} from 'antd';
import logo_full from "../asset/img/logo-mp.png"
import {Link} from 'react-router-dom';
import { checkIfMobile } from '../utils/utils'

import '../asset/style/login.css'

class NormalLoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      redirectPage: this.props.redirectPage
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount = () => {
    let isMobile = checkIfMobile();
    document.documentElement.style.setProperty('--login-div-size', isMobile ? "20em" : "40em");
  }

  componentWillMount() {
    this.props.dispatch(getCsrfToken());
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.dispatch(login(values));
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    if (this.props.loginStatus === true) {
      return <Redirect to={this.state.redirectPage} />;
    }
    return (
      <Row>
        <Col className="login-form overlayed-component">
          <Link to={'/'}><img className="login-logo" src={logo_full} /></Link>
          <p className="morphle-title unselectable" > Login to Morphle </p>
          { this.props.demoLogin ? 
          [
            <p key={0} className="demo-login">For Accessing Demo Scans</p>,
            <p key={1} className="demo-login"><b>username</b> : morphledemo</p>,
            <p key={2} className="demo-login"><b>password</b> : demouser1234</p>
            ]  : undefined }
          <Form onSubmit={this.handleSubmit}>
            <Form.Item>
              {getFieldDecorator("username", {
                rules: [{ required: true, message: "Please input your username!" }]
              })(
                <Input
                  prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                  placeholder="Username"
                />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator("password", {
                rules: [{ required: true, message: "Please input your Password!" }]
              })(
                <Input
                  prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                  type="password"
                  placeholder="Password"
                />
              )}
            </Form.Item>
            <Form.Item style={{ display: "none" }}>
              {
                getFieldDecorator("csrfmiddlewaretoken", {
                valuePropName: "Checked",
                initialValue: this.props.csrfToken
              })(<Checkbox />)}
            </Form.Item>
            {this.props.isWrongCredential?<div style={{color:"red"}}>Invalid Username or Password. <br></br> Mail at contact[at]morphle.in to reset if forgotten.</div>:<div></div>}
            {this.props.isServerUnreachable?<div style={{color:"red"}}>Server is Unreachable. Please Contact Administrator.</div>:<div></div>}
            <Form.Item>
              {
                getFieldDecorator("remember", {
                valuePropName: "checked",
                initialValue: true
              })(<Checkbox>Remember me</Checkbox>)}
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={this.props.isFetching}>
                Enter
              </Button>
            </Form.Item>
          </Form>
        </Col>
        {/* <Col span={4} >
        <img height="500px" margin-top="1%" alt="Morphle Brochure"
          src={require('../asset/img/morphle-brochure.jpg')} 
        />
        </Col> */}
      </Row>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(NormalLoginForm);

const mapStateToProps = state => {
  return state.loginAlerts;
};

export default connect(mapStateToProps)(WrappedNormalLoginForm);